import {
  PHYS_SCALE,
  b2DistanceJointDef,
  b2PrismaticJointDef,
  b2Vec2,
} from "./box2d-compat.js";
import { ScriptedLevelRuntime } from "./scripted-level-runtime.js";

export class LevelTwoRuntime extends ScriptedLevelRuntime {
  constructor(levelData, clock, runtimeState = null, options = {}) {
    super(levelData, clock, {
      deathY: 550,
      dynamicSprites: ["kickBall", "movePlatform"],
      hazards: [],
    }, runtimeState, options);
    this.beginFlag = runtimeState?.beginFlag ?? true;
  }

  configureLevel() {
    const kickBallBody = this.dynamicBodies.kickBall;
    const movePlatformBody = this.dynamicBodies.movePlatform;
    const ground = this.world.GetGroundBody();

    const distanceJoint = new b2DistanceJointDef();
    distanceJoint.Initialize(
      kickBallBody,
      ground,
      new b2Vec2(148 / PHYS_SCALE, 305 / PHYS_SCALE),
      new b2Vec2(87 / PHYS_SCALE, 209 / PHYS_SCALE),
    );
    this.joints.push(this.world.CreateJoint(distanceJoint));

    const prismaticJoint = new b2PrismaticJointDef();
    prismaticJoint.Initialize(movePlatformBody, ground, movePlatformBody.GetWorldCenter(), new b2Vec2(1, 0));
    prismaticJoint.enableLimit = false;
    prismaticJoint.enableMotor = false;
    this.world.CreateJoint(prismaticJoint);

    this.movePlatformBodyDirection = 1;
  }

  updateLevelBodies() {
    const movePlatformBody = this.dynamicBodies.movePlatform;
    const movePlatform = movePlatformBody.GetPosition().x * PHYS_SCALE;
    if (movePlatform < 390) {
      this.movePlatformBodyDirection = 1;
    }
    if (movePlatform > 550) {
      this.movePlatformBodyDirection = -1;
    }
    movePlatformBody.SetLinearVelocity(new b2Vec2(2 * this.movePlatformBodyDirection, 0));
  }
}
